import React, { Fragment, Suspense, lazy } from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'

import useUser from 'logic/user/user.hook'
import { ROLE_ADMIN, ROLE_VIEWER } from 'logic/user/user.dto'
import ViewerTimeline from 'pages/logged_in/viewer/timeline/Timeline.logic'
import AdminTimeline from 'pages/logged_in/admin/timeline/Timeline.logic'

const Home = lazy(() => import('pages/logged_out/Main'))
const Admin = lazy(() => import('pages/logged_in/admin/Main'))
const Viewer = lazy(() => import('pages/logged_in/viewer/Main'))

// TODO: while user is not loaded (it will end in the home, then it will push back to the actual router)
// therefore, we must do a loading untill everything is ready on the store
const MainRouter = () => {
    const {
        user: { roles },
    } = useUser()
    return (
        <Suspense fallback={<Fragment />}>
            <BrowserRouter>
                <Switch>
                    {roles && roles[0] === ROLE_ADMIN && (
                        <Route path='/admin'>
                            <Admin />
                        </Route>
                    )}
                    {roles && roles[0] === ROLE_ADMIN && (
                        <Route path='/item/:id'>
                            <AdminTimeline />
                        </Route>
                    )}
                    {roles && roles[0] === ROLE_VIEWER && (
                        <Route path='/viewer'>
                            <Viewer />
                        </Route>
                    )}
                    {roles && roles[0] === ROLE_VIEWER && (
                        <Route path='/item/:id'>
                            <ViewerTimeline />
                        </Route>
                    )}
                    <Route>
                        <Home />
                    </Route>
                </Switch>
            </BrowserRouter>
        </Suspense>
    )
}

export default MainRouter
